import ListRoute from "./../api/index"
import "../types"

class RouteUseCase {
    constructor() {
        /** @type {ListRoute}*/
        this.api = new ListRoute()
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        const {data, err} = await this.api.getAll(queries)
        if (err && err === "record not found") {
          return {data: null, err: null}
        }
        return {data, err}
    }

    async getLocations (queries) {
        const {data, err} = await this.api.getLocations(queries)
        if (err && err === "record not found") {
          return {data: null, err: null}
        }
        return {data, err}
    }

    async saveOne(formData) {
        return await this.api.saveOne(formData)
    }

    async getById(id) {
        const { data, err } = await this.api.getById(id);

        if (err && err === "record not found") {
            return { data: null, err: null };
        }

        return { data, err };
    }
    async update(id, formData) {
        return await this.api.update(id, formData)
    }
}

export default new RouteUseCase()
